import { appConfig as $config } from '../../app.config';
import { App } from '../App';
import { UI } from '../UI';
import { Common } from '../Common';
import { Blanks } from '../../pages/Blanks';
import { ColorVariants } from '../ColorVariants';
import { User } from '../User';
import { ApprovalRejection } from '../ApprovalRejection';

import './scss/blankinfo.scss';

export const BlankInfo = (function () {
  let reloadPage,
    $readOnly = false;
  let $choosenPanelColor, $choosenPanel;
  let $isLicensor = '';

  let mapping = {
    data: (blank) => {
      let variants = [];
      let availableAreas = [];

      // IF only one checked color
      let lastApproved = blank.variants.filter((f) => f.select).length == 1;

      $.each(blank.variants, function (k, v) {
        let files = _.findWhere(blank.variants, { color: v.color }).files;
        variants.push({
          color: v.color,
          colorHex: v.colorHex,
          colorType: v.ColorType ? v.ColorType : '',
          //availableSizes: blank.availableSizes.join(', '),
          availableSizesShort: Common.sizeRange(blank.availableSizes),
          composition: blank.composition ? blank.composition : '',
          imageUri:
            files && files.length && files[0].uri
              ? files[0].uri
              : v.blankVariantAreas && v.blankVariantAreas.length && v.blankVariantAreas[0].file.uri
              ? v.blankVariantAreas[0].file.uri
              : false,
          approved: v.select,
          // Let Color checkbox disable IF in Dialog or this is last checked color
          disabled: lastApproved && v.select ? true : false
        });
        if (v.select) {
          $.each(v.blankVariantAreas, (index, item) => {
            let availableArea = availableAreas.find((f) => f.areaTypeName == item.areaTypeName);
            let areaImage = { imageFileUrl: item.file.uri, color: v.color };
            if (!availableArea) {
              availableArea = { areaTypeName: item.areaTypeName, images: [areaImage], firstImage: item.file.uri };
              availableAreas.push(availableArea);
            } else {
              availableArea.images.push(areaImage);
            }
          });
        }
      });

      blank.bulletPoints = blank.marketingsData !== null ? blank.marketingsData.bulletPoints : null;
      blank.Description = blank.marketingsData !== null ? blank.marketingsData.detailedDescription : null;
      blank.metaTags = blank.marketingsData !== null ? blank.marketingsData.tags : null;
      blank.availableAreas = availableAreas;
      blank.variants = variants;
      blank.manufacturers = blank.manufacturingOwners.join(', ');
      //blank.sizes = shortSizeRange(blank.availableSizes);
      // Approval Item mapping
      blank.approveItem = Common.mapping.approvalObject(blank.approveItem);
      blank.createDateText = moment(blank.createdDate).format($config.appFullDateFormat);

      mapping.photoModels(blank);

      return blank;
    },
    photoModels: (blank) => {
      blank.photoModels?.forEach((pm) => (pm.imageUrl = pm.imageUrls[0]));

      if (!blank.photoModels?.length) {
        return;
      }

      const defaultKey = 'Default';

      if (blank.photoModels[0].key === defaultKey) {
        return;
      }

      blank.photoModels = blank.photoModels.sort((m) => (m.key === defaultKey ? -1 : 1));
    }
  };

  let dialog = (id = false, callback, readOnly = false, isModelImagesInfo = false) => {
    if (!id) {
      return;
    }

    $isLicensor = User.isLicensor();
    reloadPage = callback;
    $readOnly = readOnly || $isLicensor;
    $choosenPanel = null;
    $choosenPanelColor = null;

    UI.blockPage();

    $.when(App.ajaxData('blanks/info', { accountId: User.accountID(), id: id }, 'POST')).done((res) => {
      if (!res.isSuccess) {
        return UI.errorMessage(res.errorInformation.errorReason);
      }
      let blank = mapping.data(res.object);
      let data = {
        $lang: $Lang,
        blank: blank,
        readOnly: $readOnly,
        choosenPanel: $choosenPanel
      };

      App.pageData('blank_info', blank);
      let template = require('./tmpl/dialog.hbs');
      bootbox
        .dialog({
          title: $lang.blankinfo.BlankInformation,
          message: template(data),
          size: 'xl',
          className: 'modal-scrolled-content modal-blank-information'
        })
        .init(() => {
          dialogInfoinit(blank);

          if (isModelImagesInfo) {
            changeTab('blank-info-model-images', true);
          }
        });
    });
  };

  let dialogInfoinit = (blank) => {
    UI.unblockPage();
    $('[data-toggle="kt-tooltip"]').tooltip();

    let $content = $('.blank-information-content');

    blankVariansDataInit(blank);

    $('.owl-carousel', '#blank-info').owlCarousel({
      autoWidth: true,
      mouseDrag: false,
      dots: false,
      nav: true
    });

    $content
      .off()
      .on('click', '.js-action-approvereject', () => {
        ApprovalRejection.dialog({
          items: { [blank.id]: User.accountID() },
          page: 'blanks',
          callback: () => {
            reloadDialog(blank.id);
          }
        });
      })
      .on('change', '.js-action-blanksizeChange', blanksizeChange);

    $('#blank-info')
      .on('click', '.c-pic', function () {
        let _this = $(this);
        let thisimg = _this.data('imguri');
        let parent = _this.closest('.image-carousel');
        let bigimg = _this.closest('.img-content').find('.img-bg-square');
        $('.active-image', parent).removeClass('active-image');
        _this.addClass('active-image');
        bigimg.css({ backgroundImage: `url(${thisimg})` });

        // Set selected color
        $choosenPanelColor = _this.data('imgcolor');
      });

    $('#blank-info-model-images')
      .on('change', '.kt-checkbox', function () {
        const parent= $(this).closest('.model-images-list');
        const keys = Array.from($('input[type="checkbox"]:checked', parent).map((_, el) => $(el).val()));

        const request = {
          accountId: User.accountID(),
          blankId: $('#blankid').val(),
          keys
        };

        UI.blockPage();
        $.when(App.ajaxData(
          'blanks/selectModels',
          request,
          'POST',
          'application/json',
          null,
          null,
          true
        )).done(() => {
          UI.unblockPage();
          reloadPage?.();
        });
      });

    $('#blank-info-tabs').off().on('click', '.nav-link', changeTabHandler);

    $('a[data-toggle="tab"]', $content).on('shown.bs.tab', function (event) {
      // Set selected panel
      $choosenPanel = $(event.target).data('panelname') || null;
      setColorSelectedPanel();
    });

    setColorSelectedPanel();

    if ($readOnly) {
      ColorVariants.init('#blank-colors', {
        id: blank.id,
        variants: blank.variants.map((v) => {
          v.disabled = true;
          return v;
        })
      });
    } else {
      ColorVariants.init('#blank-colors', {
        id: blank.id,
        variants: blank.variants
      }).then(() => {
        $("input[id^='color$']", $content).on('change', (e) => {
          Blanks.updateBlankColor(e, () => {
            reloadDialog(blank.id);
          });
        });
      });

      sizeCheckboxDisable();
    }
  };

  let reloadDialog = (id) => {
    if (!id) return;
    UI.blockPage();

    $.when(App.ajaxData('blanks/info', { accountId: User.accountID(), id: id }, 'POST')).done((res) => {
      let blank = mapping.data(res.object);
      let data = {
        $lang: $Lang,
        blank: blank,
        readOnly: $readOnly,
        choosenPanel: $choosenPanel
      };

      let template = require('./tmpl/dialog.hbs');

      $('#blank-colors .kt-badge--bbw-color').popover('dispose');

      UI.render('.modal-body .bootbox-body', template, data).then(() => {
        App.pageData('blank_info', blank);
        dialogInfoinit(blank);
        UI.unblock('.modal-content');
        reloadPage();
      });
    });
  };

  let blanksizeChange = (e) => {
    let checked = [],
      targetEl = $(e.target),
      ItemId = $('#blankid').val();
    $('.blankinfo-size-checkbox:checked').each(function () {
      checked.push($(this).val());
    });
    if (!ItemId || checked.length < 1) {
      targetEl.prop('checked', true);
      return;
    }
    let sendData = {
      ItemId: ItemId,
      AccountId: User.accountID(),
      SelectSizesName: checked
    };

    UI.blockPage();
    $.when(App.ajaxData('blanks/selectSizes', sendData, 'POST')).done((res) => {
      if (res.isSuccess) {
        reloadDialog(ItemId);
        UI.notify({ text: $lang.alert.SuccessfullySaved, type: 'success' });
      } else {
        targetEl.prop('checked', true);
        sizeCheckboxDisable();
      }
      UI.unblockPage();
    });
  };

  let changeTabHandler = (e) => {
    const target = $(e.target);
    const name = target.data('name');

    changeTab(name);
  };

  let changeTab = (name, isForce) => {
    $('.blank-information-content').addClass('d-none');
    $(`.blank-information-content#${name}`).removeClass('d-none');

    if (!isForce) {
      return;
    }

    $(`#blank-info-tabs .nav-link`).removeClass('active');
    $(`#blank-info-tabs .nav-link[data-name=${name}]`).addClass('active');
  };

  let sizeCheckboxDisable = () => {
    if ($('.blankinfo-size-checkbox:checked').length < 2) {
      $('.blankinfo-size-checkbox:checked').attr('disabled', true);
    } else {
      $('.blankinfo-size-checkbox').attr('disabled', false);
    }
  };

  let blankVariansDataInit = (blank) => {
    let columns = [
      {
        title: $Lang.blanks.Color,
        data: 'color',
        orderable: false,
        sortable: false,
        searchable: false,
        render: (data, type, full) => {
          let colorDisplay = full.colorHex ? full.colorHex : full.color;
          return `<span title="${full.color}" style="background-color:${colorDisplay}" class="kt-badge kt-badge--square kt-badge--dot kt-badge--bbw-color"></span>  <span>${full.color}</span>`;
        }
      },
      {
        title: $Lang.blanks.Hex,
        data: 'colorHex',
        orderable: false,
        sortable: false,
        searchable: false
      },
      {
        title: $Lang.blanks.ColorType,
        data: 'colorType',
        orderable: false,
        sortable: false,
        searchable: false
      },
      {
        title: $Lang.blanks.Sizes,
        data: 'availableSizesShort',
        orderable: false,
        sortable: false,
        searchable: false
      },
      {
        title: $Lang.blanks.Composition,
        data: 'composition',
        orderable: false,
        sortable: false,
        searchable: false
      },
      {
        title: '',
        orderable: false,
        sortable: false,
        searchable: false,
        className: 'text-right',
        width: 20,
        render: (data, type, full) => {
          return '<a href="javascript:" class="details-control"><i class="fas fa-caret-circle-down fa-lg"></i></a>';
        }
      }
    ];

    let addTableFormat = require('./tmpl/table.hbs');

    let blankVariansDataTable = $('#BlankVariansDataTable').DataTable({
      serverSide: false,
      stateSave: false,
      responsive: false,
      cache: false,
      searching: false,
      columns: columns,
      processing: false,
      paging: false,
      ordering: false,
      info: false,
      buttons: [],
      data: blank.variants,
      initComplete: () => {
        $('#BlankVariansDataTable .details-control').on('click', (e) => {
          hadnleToggleMoreInfo(e);
        });
      }
    });

    let hadnleToggleMoreInfo = (e) => {
      let table = $('#BlankVariansDataTable');
      table.css({ 'border-collapse': 'separate' });
      let tr = $(e.target).closest('tr');
      let row = blankVariansDataTable.row(tr);
      if (row.child.isShown()) {
        tr.removeClass('details');
        row.child.hide();
      } else {
        tr.addClass('details');
        row.child(addTableFormat({ sizeData: blank.sizesData, lang: $lang })).show();
      }
    };
  };

  let setColorSelectedPanel = () => {
    $('.tab-pane.active .c-pic').each(function () {
      if ($(this).data('imgcolor') == $choosenPanelColor) {
        $(this).click();
      }
    });
  };

  return {
    dialog,
    reloadDialog
  };
})();
